import {LabwareDatabaseAPI, HostRepositoryStateName} from '../constants/dataEnum';
import {callAPI, getBaseURL} from '../stores/business/commonBusiness';

export const fetchFavoriteLabware = async (userId) => {
  const {method, route} = LabwareDatabaseAPI.GET_FAVORITE_LABWARE;
  const baseURL = getBaseURL(HostRepositoryStateName.AUTHORING);

  let response;

  try {
    response = await callAPI(method, baseURL, `${route}/?userId=${userId}`);
  } catch (err) {
    console.error('error on calling fetchFavoriteLabware API', err);
  }

  return response.payload;
};

export const addLabwareToFavorite = async (userId, labwareID) => {
  const {method, route} = LabwareDatabaseAPI.ADD_LABWARE_TO_FAVORITE;
  const baseURL = getBaseURL(HostRepositoryStateName.AUTHORING);

  let response;

  try {
    response = await callAPI(method, baseURL, route, {userId, labwareIds: [labwareID]});
  } catch (err) {
    console.error('error on calling addLabwareToFavorite API', err);
  }

  return response;
};

export const removeLabwareFromFavorite = async (userId, labwareID) => {
  const {method, route} = LabwareDatabaseAPI.REMOVE_LABWARE_FROM_FAVORITE;
  const baseURL = getBaseURL(HostRepositoryStateName.AUTHORING);

  let response;

  try {
    response = await callAPI(method, baseURL, route, {userId, labwareIds: [labwareID]});
  } catch (err) {
    console.error('error on calling removeLabwareFromFavorite API', err);
  }

  return response;
};
